import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Background from '../../components/Background/Background'
import FlexSection from '../../components/FlexSection/FlexSection'
import Selector from '../../components/Selector/Selector'
import Title from '../../components/Title/Title'
import SelectedSex from '../../components/SelectedSex/SelectedSex'
import Button from '../../components/Button/Button'
import bg from './help-bg.svg'

const CURRENT_STEP_NUMBER = 7
const NEXT_STEP_URL = 'konklusjon'

class Day extends Component {
  componentDidMount () {
    this.props.initStep(CURRENT_STEP_NUMBER, NEXT_STEP_URL)
  }

  render () {
    const { updateScore, currentSelectedAnswer, selectedSex } = this.props

    return (
      <Background color="#6FABFF" image={bg} className="cover">
        <FlexSection>
          <Title>
            Synes <SelectedSex selectedSex={selectedSex} /> selv at det er et problem?
          </Title>
          <div className="flex justify-between">
            <Selector
              updateScore={updateScore}
              score={1}
              id={1}
              currentSelectedAnswer={currentSelectedAnswer}
              label="Ja"
              visibleLabel={false}
              stepNumber={CURRENT_STEP_NUMBER}
              answerString={'det er et problem'}
            >
              <Button>Ja</Button>
            </Selector>
            <Selector
              updateScore={updateScore}
              score={1}
              id={2}
              currentSelectedAnswer={currentSelectedAnswer}
              label="Nei"
              visibleLabel={false}
              stepNumber={CURRENT_STEP_NUMBER}
              answerString={'det ikke er et problem'}
            >
              <Button negative>Nei</Button>
            </Selector>
          </div>
        </FlexSection>
      </Background>
    )
  }
}

Day.propTypes = {
  updateScore: PropTypes.func.isRequired,
  initStep: PropTypes.func.isRequired,
  currentSelectedAnswer: PropTypes.number
}

export default Day



// WEBPACK FOOTER //
// ./src/containers/Help/Help.js